// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';

export default class FormView extends JQueryView {
  constructor() {
    super('.custom_file_form');
  }

  @on({ event: 'change', selector: '.custom-file-input' })
  onChangeFile(e: any) {
    const $label = $('.custom-file-input').next('.custom-file-label');
    $label.html($(e.target)[0].files[0].name);
  }

  @on({ event: 'click', selector: '.file_reset' })
  onClickFileReset() {
    $('.file_reset')
      .parent()
      .prev()
      .children('.custom-file-label')
      .html('ファイルを選択...');
    $('.custom-file-input').val('');
  }
}
